<div class="container">
  <h1 mat-dialog-title>{{ "workorder.error-dialog.title" | translate }}</h1>
  <span class="spacer"></span>

  <div class="error-content" mat-dialog-content>
    <p *ngIf="data.employeeVisitOverlaps; else errorMessage">
      {{
        "workorder.error-dialog.overlap-msg"
          | translate : { overlapDay: data.overlapDay | date : "dd MMM yyyy" }
      }}
    </p>
    <ng-template #errorMessage>
      <p>
        {{ data.message }}
      </p>
    </ng-template>

    <ul class="error-message" *ngIf="data.employeeVisitOverlaps">
      <li *ngFor="let visit of data.employeeVisitOverlaps">
        <label class="employee-name">{{ visit.employeeName }} </label>
        <label class="overlap-dates">
          {{ visit.startDate | date : "HH:mm" }} -
          {{ visit.endDate | date : "HH:mm" }}
        </label>
      </li>
    </ul>
  </div>

  <div mat-dialog-actions class="actions">
    <button mat-raised-button mat-dialog-close>
      {{ "workorder.error-dialog.close" | translate }}
    </button>
  </div>
</div>
